var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 68.5,
    r: 18.5,
    fill: "url(#work-icon-3_svg__paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.093 67.28l1.233-8.03-8.222 10.438h4.933l-1.644 8.833 9.044-11.242h-5.344z",
    fill: "#F6F8FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 44h24l-5.143-5M53 52H29l5.143 5",
    stroke: "#262647",
    strokeWidth: 2.593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47c0-20.434-16.566-37-37-37S5 26.566 5 47s16.566 37 37 37a36.84 36.84 0 0017.077-4.168",
    stroke: "#262647",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "work-icon-3_svg__paint0_linear",
    x1: 88.615,
    y1: 40.08,
    x2: 76.5,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F55A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21213F"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHZpZXdCb3g9IjAgMCA5NiA5NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNzYuNSIgY3k9IjY4LjUiIHI9IjE4LjUiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPHBhdGggZD0iTTc4LjA5MzEgNjcuMjc5NUw3OS4zMjY0IDU5LjI1TDcxLjEwNDIgNjkuNjg4NEg3Ni4wMzc1TDc0LjM5MzEgNzguNTIwOEw4My40Mzc1IDY3LjI3OTVINzguMDkzMVoiIGZpbGw9IiNGNkY4RkIiLz4KPHBhdGggZD0iTTI5IDQ0SDUzTDQ3Ljg1NzEgMzkiIHN0cm9rZT0iIzI2MjY0NyIgc3Ryb2tlLXdpZHRoPSIyLjU5MzQ1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUzIDUySDI5TDM0LjE0MjkgNTciIHN0cm9rZT0iIzI2MjY0NyIgc3Ryb2tlLXdpZHRoPSIyLjU5MzQ1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTc5IDQ3Qzc5IDI2LjU2NTUgNjIuNDM0NSAxMCA0MiAxMEMyMS41NjU1IDEwIDUgMjYuNTY1NSA1IDQ3QzUgNjcuNDM0NSAyMS41NjU1IDg0IDQyIDg0QzQ4LjE1OTggODQgNTMuOTY4IDgyLjQ5NDggNTkuMDc2OSA3OS44MzIiIHN0cm9rZT0iIzI2MjY0NyIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9Ijg4LjYxNTQiIHkxPSI0MC4wNzk5IiB4Mj0iNzYuNSIgeTI9Ijg3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM1RjU1QTUiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMjEyMTNGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgWorkIcon3 as ReactComponent };